<template>
  <div class="main-layout">
    <div class="top">
      <div class="logo">
        <img class="LogImg" v-bind:src="picture" alt="标题头">
      </div>
      <div class="list">
        <div class="nav-router">
          <div class="area" style="float: left;">
            <ul>
              <li v-on:click="changeArea('110000', '北京')" :class="{se: areaName==='北京'}" style="margin-top: 15px">
                北京
              </li>
            </ul>
          </div>
          <div class="area">
            <ul>
              <li v-on:click="changeArea('110101', '东城')" :class="{se: areaName==='东城'}">东城
              </li>
              <li v-on:click="changeArea('110102', '西城')" :class="{se: areaName==='西城'}">西城
              </li>
              <li v-on:click="changeArea('110105', '朝阳')" :class="{se: areaName==='朝阳'}">朝阳
              </li>
              <li v-on:click="changeArea('110108', '海淀')" :class="{se: areaName==='海淀'}">海淀
              </li>
              <li v-on:click="changeArea('110106', '丰台')" :class="{se: areaName==='丰台'}">丰台
              </li>
              <li v-on:click="changeArea('110107', '石景山')" :class="{se: areaName==='石景山'}">石景山
              </li>
              <li v-on:click="changeArea('110111', '房山')" :class="{se: areaName==='房山'}">房山
              </li>
              <li v-on:click="changeArea('110112', '通州')" :class="{se: areaName==='通州'}">通州
              </li>
            </ul>
            <ul>
              <li v-on:click="changeArea('110113', '顺义')" :class="{se: areaName==='顺义'}">顺义
              </li>
              <li v-on:click="changeArea('110115', '大兴')" :class="{se: areaName==='大兴'}">大兴
              </li>
              <li v-on:click="changeArea('110114', '昌平')" :class="{se: areaName==='昌平'}">昌平
              </li>
              <li v-on:click="changeArea('110117', '平谷')" :class="{se: areaName==='平谷'}">平谷
              </li>
              <li v-on:click="changeArea('110116', '怀柔')" :class="{se: areaName==='怀柔'}">怀柔
              </li>
              <li v-on:click="changeArea('110109', '门头沟')" :class="{se: areaName==='门头沟'}">门头沟
              </li>
              <li v-on:click="changeArea('110228', '密云')" :class="{se: areaName==='密云'}">密云
              </li>
              <li v-on:click="changeArea('110229', '延庆')" :class="{se: areaName==='延庆'}">延庆
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import picture00 from '../assets/image/bgg.png';

export default {
  data() {
    return {
      Qx: "精细化决策支撑服务平台",
      picture: picture00,
      top: top,
      areaCode: this.$store.state.code,
      areaName: this.$store.state.name,
    }
  },
  mounted: function () {
    this.toInit();
  },
  methods: {
    changeArea: function (code, name) {
      this.areaCode = code
      this.areaName = name
      this.$store.state.code = code
      this.$store.state.name = name
    },
    toInit() {
      if (this.$route.query.code !== undefined) {
        this.init(this.$route.query.code);
      } else {
        this.init("TOCC000");
      }
    },
    init(code) {
      let ToCode = ""
      let ToName = ""
      if (code === "TOCC000") {
        ToCode = "110000"
        ToName = '北京'
      } else if (code === "TOCC101") {
        ToCode = "110101"
        ToName = '东城'
      } else if (code === "TOCC102") {
        ToCode = "110102"
        ToName = '西城'
      } else if (code === "TOCC105") {
        ToCode = "110105"
        ToName = '朝阳'
      } else if (code === "TOCC106") {
        ToCode = "110106"
        ToName = '丰台'
      } else if (code === "TOCC107") {
        ToCode = "110107"
        ToName = '石景山'
      } else if (code === "TOCC108") {
        ToCode = "110108"
        ToName = '海淀'
      } else if (code === "TOCC109") {
        ToCode = "110109"
        ToName = '门头沟'
      } else if (code === "TOCC111") {
        ToCode = "110111"
        ToName = '房山'
      } else if (code === "TOCC112") {
        ToCode = "110112"
        ToName = '通州'
      } else if (code === "TOCC113") {
        ToCode = "110113"
        ToName = '顺义'
      } else if (code === "TOCC114") {
        ToCode = "110114"
        ToName = '昌平'
      } else if (code === "TOCC115") {
        ToCode = "110115"
        ToName = '大兴'
      } else if (code === "TOCC116") {
        ToCode = "110116"
        ToName = '怀柔'
      } else if (code === "TOCC117") {
        ToCode = "110117"
        ToName = '平谷'
      } else if (code === "TOCC228") {
        ToCode = "110228"
        ToName = '密云'
      } else if (code === "TOCC229") {
        ToCode = "110229"
        ToName = '延庆'
      }else{
        ToCode = "110000"
        ToName = '北京'
      }
      this.areaCode = ToCode
      this.areaName = ToName
      this.$store.state.code = ToCode
      this.$store.state.name = ToName
    },
  },
  watch: {
    '$store.state.code': function (newCode, oldCode) {
      console.log(newCode + ":" + oldCode);
    },
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>

.toptips {
  height: 42px;
  line-height: 42px;
  font-family: "微软雅黑";

  .container {
    position: relative;
    height: 42px;
  }

  .t1 {
    font-size: 16px;
    color: #FFFFFF;
    position: absolute;
    left: 61px;
    top: 0;
  }

  .t2 {
    font-size: 16px;
    position: absolute;
    right: 5%;
    top: 0;

    .guide_item {
      padding-right: 7px;
      display inline-block;
      cursor pointer;
      text-align center;
      position relative;
      color: white;

      img {
        position absolute
        width 25px
        height 22px
        right 0
        top 5px
      }
    }

    .itemName {
      font-weight 551;
    }

    .on {
      color: #ffe100;
    }
  }
}

.text-user {
  font-size 15px;
  color: #003366;
  height 25px;
  font-weight normal;
  line-height 25px;
  text-align right;
}

.button {
  text-decoration underline;
  cursor pointer;
  margin-right 5px;
}

.button:hover {
  color red;
}

.top {
  height: 80px;
  position: relative;
  z-index: 100;
  background: #ffffff;
  border-bottom: 2px solid #d1cfdc;

  .logo {
    width: 160px;
    height: 80px;
    position: absolute;
    left: 48px;

    img {
      display: block;
      height: 85%;
      margin-top: 7px;
      background-position: left center;
      background-repeat: no-repeat;
    }
  }

  .list {
    position: absolute;
    right: 5%;
    top: 0;
  }

  .Right {
    position: absolute;
    right: 4%;
    top: 5px;

    .RightNav {
      margin: 16px;
      padding: 0;
      display: flex;
    }

    p {
      font-family "楷体"
      font-size 30px
      font-weight 800;
      color: #4595e6;
    }
  }

  .nav-router {
    margin: 9px;
    padding: 0;
    display: flex;
  }
}

ul li {
  position relative;
  display inline-block;
  cursor pointer;
  color #FFfff;
  font-size 16px;
  text-align center
  height 30px;
  font-weight: 551;
  line-height 30px;
  width 55px;

  img {
    position absolute;
    top 0;
    right 0;
    height 18px;
    width 19px;
  }
}

.area {
  display inline-block;
}

.se {
  background-color #FFD400;
}

.image_horn {
  margin: 10px;
  float: right;
  vertical-align: middle;
  width: 20px;
  height: 20px
  cursor pointer
}
</style>
